import { render } from "./ItemPriceStatistics.vue?vue&type=template&id=34e57aa6&scoped=true"
import script from "./ItemPriceStatistics.vue?vue&type=script&lang=js"
export * from "./ItemPriceStatistics.vue?vue&type=script&lang=js"

import "./ItemPriceStatistics.vue?vue&type=style&index=0&id=34e57aa6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e57aa6"]])

export default __exports__